import { Form, Input, message } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useAddOrganizationMutation,
  useEditOrganizationMutation,
} from "src/app/services/management";
import {
  IAddOrganization,
  IOrganizationTable,
} from "src/app/services/management/type";
import { useGetProfileMutation } from "src/app/services/users";
import { PlusIcon } from "src/assets/svg";
import CustomButton from "src/components/common/button";
import CustomModal from "src/components/common/modal";
import ModalFooter from "src/components/common/modal/ModalFooter";
import ModalHeader from "src/components/common/modal/ModalHeader";

interface Props {
  addVisible: boolean;
  editableData?: IOrganizationTable;
  setEditableData: React.Dispatch<
    React.SetStateAction<IOrganizationTable | undefined>
  >;
}

function AddCompany({ addVisible, editableData, setEditableData }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditableData(undefined);
    form.resetFields();
  };

  //Form section
  const [getProfile] = useGetProfileMutation();
  const [addOrganization, { isSuccess: addStatus }] =
    useAddOrganizationMutation();
  const [editOrganization, { isSuccess: editStatus }] =
    useEditOrganizationMutation();
  const [form] = Form.useForm();
  const onFinish = (val: IAddOrganization) => {
    if (editableData) editOrganization({ id: editableData.id, body: val });
    else addOrganization(val);
  };

  useEffect(() => {
    if (addStatus) {
      message.success("Organization added successfully!");
      closeModal();
      getProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addStatus]);

  useEffect(() => {
    if (editStatus) {
      message.success(`${editableData?.title} edited successfully!`);
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editStatus]);

  //Set data for edit
  const handleSet = () => {
    if (editableData) {
      showModal();
      form.resetFields();
      let { title } = editableData;
      form.setFieldsValue({
        title,
      });
    }
  };

  useEffect(() => {
    handleSet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableData]);

  return (
    <div className="add">
      {addVisible && (
        <CustomButton
          className="content-top-btn"
          height={38}
          onClick={showModal}
        >
          <div className="content-top-btn-content">
            <PlusIcon /> {t("common.add")}
          </div>
        </CustomButton>
      )}

      <CustomModal
        open={isModalOpen}
        width={640}
        onCancel={closeModal}
        centered={true}
      >
        <ModalHeader
          title={`${
            editableData
              ? editableData.title + " " + t("subHelper.editInformation")
              : t("company.addCompany")
          }`}
        />

        <Form
          form={form}
          name="normal_login"
          className="form-form"
          onFinish={onFinish}
          layout={"vertical"}
          requiredMark={false}
        >
          <Form.Item
            name="title"
            label={t("company.nameCompany") + "*"}
            rules={[{ required: true, message: t("company.enterCompany") }]}
            className="full"
          >
            <Input />
          </Form.Item>
          <ModalFooter onCancel={closeModal} />
        </Form>
      </CustomModal>
    </div>
  );
}

export default AddCompany;
